export default __webpack_public_path__ + "safari-pinned-tab.4ea971c3.svg";